// Static content + media for the marketing site
export const BRAND = {
  name: "Emergent Sacramento",
  shortName: "EMERGENT",
  tagline: "Official Emergent Technologies Partner · Sacramento, CA · Est. 1998",
  email: "hello@emergentsac.com",
  phone: "916-WEB-8101",
  phoneTel: "9169328101",
  address: "3525 4th Ave, Sacramento, CA 95817",
  social: {
    instagram: "#",
    linkedin: "#",
    x: "#",
    youtube: "#",
  },
};

export const MEDIA = {
  heroNetwork:
    "https://images.pexels.com/photos/10325707/pexels-photo-10325707.png?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  sacramento:
    "https://images.pexels.com/photos/34276128/pexels-photo-34276128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  social:
    "https://images.unsplash.com/photo-1694109016554-9a52bff4e9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  team:
    "https://images.pexels.com/photos/8117476/pexels-photo-8117476.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  portfolio: [
    "https://images.unsplash.com/photo-1702479743967-3dcccd4a671d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1697292859724-0d2501966448?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1702479744181-2d6b58941583?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1702479744120-98fffb81bf6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  ],
};

export const SERVICES = [
  {
    id: "web",
    num: "01",
    title: "Web Design & Development",
    blurb:
      "High-performance, conversion-focused websites and web apps built on modern stacks. Fast, accessible, and pixel-perfect.",
    points: ["Custom websites", "Web applications", "E-commerce", "CMS & landing pages"],
  },
  {
    id: "brand",
    num: "02",
    title: "Branding & Graphic Design",
    blurb:
      "Identity systems that make Sacramento businesses unforgettable — logos, guidelines, and visual language with intent.",
    points: ["Logo & identity", "Brand guidelines", "Print & packaging", "Pitch decks"],
  },
  {
    id: "seo",
    num: "03",
    title: "SEO & Digital Marketing",
    blurb:
      "Get found by the right people. Local SEO, paid ads, and analytics engineered to drive measurable revenue.",
    points: ["Local SEO", "Google & Meta Ads", "Analytics & CRO", "Content strategy"],
  },
  {
    id: "social",
    num: "04",
    title: "Social Media Campaigns",
    blurb:
      "Full-funnel social campaigns — strategy, content, video, and community management that turns scrollers into customers.",
    points: ["Campaign strategy", "Content & video", "Paid social", "Community management"],
  },
];

export const PROCESS = [
  { num: "01", title: "Discover", text: "We dig into your goals, audience, and local market to map the opportunity." },
  { num: "02", title: "Design", text: "We craft identity, UX, and campaign concepts engineered to convert." },
  { num: "03", title: "Deploy", text: "We build, launch, and integrate — fast, tested, and on-brand." },
  { num: "04", title: "Drive", text: "We optimize with data, scaling what works to grow your revenue." },
];

export const PACKAGES = [
  {
    name: "Launch",
    price: "$1,900",
    tag: "Starter",
    desc: "Perfect for new Sacramento businesses getting online.",
    features: ["5-page custom website", "Mobile responsive", "Basic SEO setup", "Contact & lead forms", "2 rounds of revisions"],
    highlight: false,
  },
  {
    name: "Growth",
    price: "$4,500",
    tag: "Most Popular",
    desc: "For established brands ready to scale visibility & leads.",
    features: ["Everything in Launch", "Brand identity refresh", "Local SEO + Google Business", "Social media setup", "1 month ad management", "Analytics dashboard"],
    highlight: true,
  },
  {
    name: "Dominate",
    price: "Custom",
    tag: "Full Service",
    desc: "Complete digital partner for market-leading brands.",
    features: ["Everything in Growth", "Full social campaigns", "Video & content production", "Ongoing ad management", "Monthly strategy calls", "Priority support"],
    highlight: false,
  },
];

export const TESTIMONIALS = [
  {
    quote: "They rebuilt our site and ran our social campaign — we booked more leads in 60 days than the entire previous year.",
    name: "Marcus Reyes",
    role: "Owner, Midtown Auto Spa",
  },
  {
    quote: "The branding is stunning and the local SEO put us on the map. Genuinely the best partner we've worked with in Sacramento.",
    name: "Priya Nair",
    role: "Founder, Capitol Wellness Co.",
  },
  {
    quote: "Professional, fast, and data-driven. Our ad spend finally has ROI we can actually see and measure.",
    name: "Dana Whitfield",
    role: "Director, RiverCity Realty",
  },
];

export const STATS = [
  { value: "25+", label: "Years Experience" },
  { value: "120+", label: "Projects Shipped" },
  { value: "3.4x", label: "Avg. Lead Growth" },
  { value: "1998", label: "Est. in Sacramento" },
];
